import { render, staticRenderFns } from "./WorkbenchLayout.vue?vue&type=template&id=826f9402&scoped=true&"
import script from "./WorkbenchLayout.vue?vue&type=script&lang=ts&"
export * from "./WorkbenchLayout.vue?vue&type=script&lang=ts&"
import style0 from "./WorkbenchLayout.vue?vue&type=style&index=0&id=826f9402&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826f9402",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zfh/dev/targus-micor/targus-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('826f9402')) {
      api.createRecord('826f9402', component.options)
    } else {
      api.reload('826f9402', component.options)
    }
    module.hot.accept("./WorkbenchLayout.vue?vue&type=template&id=826f9402&scoped=true&", function () {
      api.rerender('826f9402', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/WorkbenchLayout.vue"
export default component.exports